import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { blue, navy, glass, glowFocus, transition } from './colorUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Input', 'blueTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      transition,
      borderRadius: 4,
      background: `${glass.input} !important`,
      borderColor: `${navy[700]} !important`,
      color: `#e2e8f0 !important`,
      caretColor: blue[500],

      '&::placeholder': {
        color: `#475569 !important`,
      },

      '&:hover': {
        borderColor: `${blue[500]}60 !important`,
      },

      '&:focus, &-focused': {
        borderColor: `${blue[500]} !important`,
        boxShadow: `${glowFocus} !important`,
      },

      [`${componentCls}-prefix, ${componentCls}-suffix`]: {
        color: `#94a3b8 !important`,
      },
    },

    // Input 包裹器 (affix-wrapper)
    [`${componentCls}-affix-wrapper${DOT_PREFIX}`]: {
      transition,
      borderRadius: 4,
      background: `${glass.input} !important`,
      borderColor: `${navy[700]} !important`,

      '&:hover': {
        borderColor: `${blue[500]}60 !important`,
      },

      '&-focused': {
        borderColor: `${blue[500]} !important`,
        boxShadow: `${glowFocus} !important`,
      },
    },
  }
})
